export default [
  'Know more about Web Accessibility',
  'Do you first open source contribution',
  'Clean up your PC or Phone',
  'Clean up your inbox',
  'Learn Express.js',
  'Learn to greet someone in a new language',
  'Learn Vue',
  'Learn React',
  'Drink a beer',
  'Learn how to play a new sport',
  "Text a friend you haven't talked to in a long time",
  'Learn a new programming language',
  'Learn how to fold a paper crane',
  'Find a DIY to do',
  'Learn about the Golden Ratio',
  'Volunteer at a local animal shelter',
  'Play a game of Monopoly',
  'Bake pastries for you and your neighbor',
  "Bake something you've never tried before",
  'Take your dog on a walk',
  'Meditate for five minutes',
  "Start a book you've never gotten around to reading",
  'Take a caffeine nap',
  'Take a bubble bath',
  'Go to a nail salon',
  'Listen to your favorite album',
  'Learn to play a new instrument',
  'Teach your dog a new trick',
  'Make a to-do list for your week',
  'Go swimming with a friend',
  'Go on a long drive',
  "Watch a movie you'd never usually watch",
  'Go see a movie in theaters with a few friends',
  'Draw and color a Mandala',
  'Rearrange and organize your room',
  'Pot some plants and put them around your house',
  "Plan a vacation you've always wanted to take",
  'Take your cat on a walk',
  'Have a football scrimmage with some friends',
  'Fill out a basketball bracket',
  'Play a game of tennis with a friend',
  'Catch up with a friend over a lunch date',
  'Learn how to iceskate or rollerskate',
  'Go to a concert with local artists with some friends',
  'Explore the nightlife of your city',
  "Fix something that's broken in your house",
  'Wash your car',
  'Hold a yard sale',
  'Donate blood at a local blood center',
  'Volunteer and help out at a senior center',
  'Shop at support your local farmers market',
  'Learn a new recipe',
  'Create a cookbook with your favorite recipes',
  'Volunteer at your local food shelter',
  'Create or update your resume',
  'Paint the first thing you see',
  "Start a blog for something you're passionate about",
  'Start a garden',
  "Clean out your closet and donate the clothes you've outgrown",
  'Catch up on world news',
  'Create a personal website',
  'Listen to a new podcast',
  'Have a paper airplane contest with some friends',
  'Learn calligraphy',
  'Start a collection',
  'Go to a local thrift shop',
  'Make a couch fort',
  'Pick up litter around your favorite park',
  'Buy a new house decoration',
  'Write a thank you letter to an influential person in your life',
  'Clean out your car',
  'Write a short story',
  'Do something nice for someone you care about',
  'Think of a new business idea',
  'Clean out your garage',
  'Learn to sew on a button',
  'Learn how to french braid hair',
  'Learn how to whistle with your fingers',
  'Learn to write with your nondominant hand',
  'Make bread from scratch',
  'Make a budget',
  'Make a simple musical instrument',
  'Go to the gym',
  "Try a food you don't like",
  'Conquer one of your fears',
  'Go to a concert with some friends',
  'Go to the library and find an interesting book',
  'Go to an escape room',
  'Go to a karaoke bar with some friends',
  'Repaint a room in your house',
  'Pull a harmless prank on one of your friends',
  'Take a spontaneous road trip with some friends',
  'Go stargazing',
  'Invite some friends over for a game night',
  'Make homemade ice cream',
  'Start a daily journal',
  'Go to a music festival with some friends',
  'Make a bucket list',
  'Binge watch a trending series',
  'Learn how to make a website',
  'Create and follow a savings plan',
  'Watch a classic movie',
  'Plan a trip to another country',
  'Learn how the internet works',
  'Take a hike at a local park',
  'Make tie dye shirts',
  'Make a scrapbook with pictures of your favorite memories',
  'Have a picnic with some friends',
  'Have a bonfire with your close friends',
  'Memorize the fifty states and their capitals',
  'Take a class of something that interests you',
  "Resolve a problem you've been putting off",
  'Make a new friend',
  'Take a nap',
  'Learn a new language',
  'Go to the gym',
  'Brush your teeth',
  'Drink some water',
  'Make a tea',
  'Fork this app and learn something in the process',
  'Go for a bike ride',
  'Build a spaceship',
  'Draw a horse',
  'People watch',
  'Go day - drinking',
  'Play chess',
  'Start a random game of Tag with a stranger',
  'Play 2048 mobile game',
  'Make a list of things to do and then take a nap',
  'Learn to skateboard',
  'Look through the GitHub repo 👀',
  'Go for a walk ',
  'Netflix and chill',
  'Give bullet journaling a try',
  'Go for a run!',
  'Go do that dance.',
  'Take a shit',
  'Put down your phone and hang out with your closest person near you.',
  'Clip your toe nails',
  'Walk for 30 mins',
  'Meditate for 10 mins',
  'Call your mother',
  'Drink whiskey!',
  'Take an online course',
  'Pick your nose',
  'Dance with yourself!',
  'Learn React',
  'Play an Escape Room',
  'Go skating',
  'Go for a walk in Chinatown',
  'Take A Shower',
  'Meditate',
  'Learn About Islam',
  'Learn Magic Tricks',
  'Drink Mezcal',
  'Brew your own kombucha',
  'Invite a stranger that you see often out for a coffee',
  'Call Mom',
  'Re-organize your library',
  'Clean out the refrigerator',
  'Clean up your wardrobe',
  'Leave the house and walk without a destination in mind for 15 minutes and decide where to go on crossroads',
  'Learn five colours in French',
  'Put on moisturizer',
  'Do a plank',
  'Do 10 squads',
  "Revisit Your New Year's Resolutions",
  'Make a smoothie',
  'Grab some boba with friends!',
  'Sing a Song',
  'Take a bus till the last stop and then explore that neighborhood',
  'Go outside and mark your territory',
  'Clean your room',
  'Yoga',
  'Draw something!',
  'When will you code',
  'Play Zelda',
  'Play Chess',
  'Go for a swim',
  'Do some writing',
  'Leave Facebook',
  "Make a plan to surprise a friend with something they'd like",
  'Try pat your head and rub your belly',
  'Code to create some awesome app.',
  'Learn programming 😃',
  'Take a walk',
  'Watch clouds pass by',
  'Eat some fish',
  'Sneak into the cinema',
  'Take a walk with your dog',
  'Read a few chapters of a book',
  'Fuck with a dog',
  'Read a book',
  'Skydiving',
  'Learn to bunnyhop',
  'Go drink',
  'Balance golf balls',
  'Create some cool IFTTT automations!',
  'Call or message a friend you know you’ve hurt in the past and maybe make it up to them.',
  'Eat some Khinkali',
  'Build a boredaf.app',
  'Play League of Legends',
  'Play game',
  'Learn to solve a Rubiks Cube',
  'Bake a cake ',
  'Drop a Database',
  'Ride a unicycle in your swimming suit.',
  'Mediate for at least 5 5 minutes',
  'Testing code',
  'Draw',
  'Play paintball',
  'Have a nap',
  'Take up drawing',
  'Cook yourself a fast meal.',
  'Painting',
  'Run up and down the stairs 10 times',
  'Do Rock Climbing',
  'Compliment yourself',
  'Write a letter (to a relative, to an old friend)',
  'Wrangle horses',
  'Do 10 push-ups ',
  'Make a paper airplane and throw it at someone ',
  'Do speed math',
  'Fill an A4 paper with circles',
  'Add an activity to this app',
  "Try to solve a Rubik's Cube!",
  'Learn to Moon Walk',
  'Go to play basketball',
  'Go fishing',
  'Name all the US states',
  'Re-lace your shoes',
  'Order chinese food',
  "Read a famous book you've never read",
  'Record yourself singing a song.',
  'Write someone a letter.',
  'Dust your blinds',
  'Look for 4 leaf clovers',
  'Hug a tree',
  'Dance like nobody’s watching',
  'Put together a jigsaw puzzle',
  'Write a To-Do list',
  'Wash your sheets',
  'Compliment yourself',
  'Got to the library',
  'Clean out your refrigerator',
  'Change your passwords',
  'Play with kids',
  'Join a game jam',
  'Learn the lyrics to a new song you liked.',
  'Lasso the moon',
  'Wear an eyepatch',
  'Pet a goat',
  'Practice your handstand',
  'Make a kite with cheap materials',
  'Go fly a selfmade kite',
  'Find five reasons to smile',
  'Call someone and tell them you love them'
]
